import React, {Component} from "react";
import styles from './detailBloodStationSchedule.module.scss';
import {ISchedule} from "../../../entities/detail_blood_station";
import moment from "moment";
import {Modal, TransitionablePortal} from "semantic-ui-react";
import {incline} from 'lvovich';
import DetailBloodStationNoInfo from "../detailBloodStationNoInfo";

class TodayExtendedSchedule {
  id: number;
  dow: string;
  start: string;
  end: string;
  isOpenedNow: boolean;

  constructor(schedule: ISchedule, isNext?: boolean) {
    this.id = schedule?.id;
    this.dow = isNext ? incline({first: schedule?.dow.toLowerCase()}, 'genitive').first : schedule?.dow;
    this.start = schedule?.start;
    this.end = schedule?.end;
    this.isOpenedNow = isNext ? false : this.isTodayIsOpen(schedule?.start, schedule?.end);
  }

  isTodayIsOpen = (start: string, end: string) => {
    if (start && end) {
      const nowMoment = moment()
      const nowDate = new Date()
      const [startTimeHours, startTimeMinutes] = start?.split(':').map(Number)
      const [endTimeHours, endTimeMinutes] = end?.split(':').map(Number)
      const startDate = moment(moment(nowDate.setHours(startTimeHours)).toDate().setMinutes(startTimeMinutes)).toDate()
      const endDate = moment(moment(nowDate.setHours(endTimeHours)).toDate().setMinutes(endTimeMinutes)).toDate()
      return nowMoment.isBetween(startDate, endDate)
    } else {
      return false
    }
  }
}

export default class DetailBloodStationSchedule extends Component<any, any> {
  props: {
    schedule: ISchedule[];
    isMobile: boolean;
  }

  constructor(props) {
    super(props);
    this.state = {
      openedScheduleModal: false
    }
  }

  getTodaySchedule = (schedule: ISchedule[]) => {
    const todayMoment = moment().format('dddd');
    return new TodayExtendedSchedule(schedule.find(item => item.dow.toLowerCase() === todayMoment))
  }

  getNextSchedule = (schedule: ISchedule[], todaySchedule: TodayExtendedSchedule) => {
    return new TodayExtendedSchedule(schedule[todaySchedule.id] || schedule[0], true)
  }

  openScheduleModal = () => {
    this.setState({
      openedScheduleModal: !this.state.openedScheduleModal
    })
  }

  render() {
    const {props, state, openScheduleModal} = this;
    const {openedScheduleModal} = state;
    const {schedule, isMobile} = props;
    let todaySchedule = this.getTodaySchedule(schedule);
    if (!todaySchedule.isOpenedNow) {
      todaySchedule = this.getNextSchedule(schedule, todaySchedule)
    }
    const {isOpenedNow, start, end, dow} = todaySchedule
    const isNotServer = typeof window !== 'undefined'
    if (todaySchedule) {
      return (
        <>
          <div className={styles.DetailBloodStationSchedule}>
            <div
              onClick={todaySchedule.id ? openScheduleModal : null}
              className={styles.DetailBloodStationSchedule_Container}>
              {todaySchedule.id && <div className={styles.DetailBloodStationSchedule_Container_Left}>
                {isOpenedNow && <span className={styles.DetailBloodStationSchedule_Container_LeftOpened}>Открыто</span>}
                {!isOpenedNow &&
                <span
                    // className={styles.DetailBloodStationSchedule_Container_LeftClosed}>{isNotServer ? `Закрыто до ${dow}` : 'Закрыто'}</span>}
                    className={styles.DetailBloodStationSchedule_Container_LeftClosed}>Закрыто</span>}
                  <p>{start} - {end}</p>
              </div>}
              {!todaySchedule.id && <DetailBloodStationNoInfo text={'График работы отсутствует'}/>}
              <div className={styles.DetailBloodStationSchedule_Container_Right}>
                <img src="/static/images/icons/detailBSSchedule.svg" alt=""/>
              </div>
            </div>
          </div>
          <TransitionablePortal
            open={openedScheduleModal}
            transition={{animation: isMobile ? 'slide up' : 'scale', duration: 200}}>
            <Modal
              style={isMobile ? {
                top: 'auto',
                width: '100%',
                margin: 0,
                height: 'auto',
                bottom: 0,
                borderRadius: '6px 6px 0 0',
              } : {
                top: 'auto',
                bottom: 'auto',
                margin: 0,
                height: 'auto',
                left: 'auto',
                right: 'auto',
                maxWidth: '350px'
              }}
              onClose={openScheduleModal}
              open={openedScheduleModal}>
              <Modal.Content>
                <div className={styles.MobileModal}>
                  <div className={styles.MobileModal_Header}>
                    <span>График работы</span>
                    <img
                      onClick={openScheduleModal}
                      src="/static/images/icons/close.svg" alt=""/>
                  </div>
                  <div className={styles.MobileModal_Content}>
                    {schedule.map(item => <ScheduleModalItem key={item.dow} schedule={item}/>)}
                  </div>
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        </>
      )
    } else return null
  }
}

const ScheduleModalItem = ({schedule}) => {
  const {dow, start, end} = schedule;
  const isToday = moment().format('dddd') === dow.toLowerCase()
  return (
    <div className={styles.MobileModal_Content_Item}>
      {isToday && <div className={styles.MobileModal_Content_Item_Today}/>}
      <span>{dow}</span>
      <span>{start} - {end}</span>
    </div>
  )
}
